import { SPEAKERS, SPEAKER_IMAGES } from "@/data/content";
import Reveal from "@/components/Reveal";
import { Wifi } from "lucide-react";

export default function Speakers() {
  return (
    <section id="speakers" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-paper">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">04 · Speakers</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] max-w-3xl">
            Voices from India and around the world.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {SPEAKERS.map((sp, i) => (
            <Reveal key={sp.name} delay={(i % 5) * 0.05}>
              <div className="group relative bg-paper overflow-hidden" data-testid={`speaker-${i}`}>
                <div className="aspect-[4/5] overflow-hidden bg-ink/5">
                  <img
                    src={sp.img || SPEAKER_IMAGES[i]}
                    alt={sp.name}
                    loading="lazy"
                    className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                </div>
                {sp.online && (
                  <span className="absolute top-3 right-3 flex items-center gap-1 bg-ink/80 text-white font-mono text-[9px] uppercase tracking-wider px-2 py-1">
                    <Wifi size={10} /> Online
                  </span>
                )}
                <div className="p-4 bg-paper">
                  <h3 className="font-heading text-base font-semibold leading-tight tracking-tight">{sp.name}</h3>
                  <p className="text-ink/55 text-xs leading-snug mt-1.5">{sp.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <p className="mt-8 font-mono text-xs text-ink/40">Speaker list expanding. More global names to be announced.</p>
        </Reveal>
      </div>
    </section>
  );
}
